/*
 * domains (utils)
 */
import { Env } from "./environment.utils"

const BASE_API_DOMAIN = "api.timeprox.com"

export function getApiDomainName(
	env: string = Env,
	addMissingHttps = true,
): string {
	if (env === "prod") {
		if (addMissingHttps) {
			return `https://${BASE_API_DOMAIN}`
		}
		return BASE_API_DOMAIN
	} else {
		const envApiDomain = BASE_API_DOMAIN.replace("api.", `api.${env}.`)
		if (addMissingHttps) {
			return `https://${envApiDomain}`
		}
		return envApiDomain
	}
}

export function getEnvDomainName(
	domain: string,
	env: string = Env,
	addMissingHttps = false,
): string {
	if (env === "prod") {
		if (addMissingHttps && !domain.includes("://")) {
			return `https://${domain}`
		}
		return domain
	} else if (domain.includes("://")) {
		return domain.replace("://", `://${env}.`)
	}
	const envDomain = `${env}.${domain}`
	if (addMissingHttps) {
		return `https://${envDomain}`
	}
	return envDomain
}

export function getEnvDomainNames<T extends Record<string, string>>(
	domains: T,
	env: string = Env,
	appendHttps = true,
) {
	const envDomains = {} as Record<keyof T, string>
	for (const key in domains) {
		let domain: string = domains[key]
		if (appendHttps && !domain.includes("://")) {
			domain = `https://${domain}`
		}
		envDomains[key] = getEnvDomainName(domain, env)
	}
	return envDomains
}

export function getProjectDomain(project: string): string | null {
	switch (project) {
		case "timeprox":
			return "timeprox.com"
		case "gaming":
			return "gaming.timeprox.com"
		case "psychology":
			return "psychology.timeprox.com"
		case "status":
			return "status.timeprox.com"
		case "forever-names":
			return "forever-names.com"
		case "storybook":
			return "storybook.timeprox.com"
		case "blog":
			return "blog.timeprox.com"
		case "docs":
			return "docs.timeprox.com"
		case "helix-docs":
			return "docs.helix.timeprox.com"
		case "helix-storybook":
			return "storybook.helix.timeprox.com"
		default:
			return null
	}
}
